export const NOT_FOUND = 'not found';

// eslint-disable-next-line max-len
export const PASSWORD_REGEXP = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[ !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])?.{12,}$/;



// WEBPACK FOOTER //
// ./src/utils/consts.js